import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class BigCar extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, sizeId) {
    super(scene);

    this.carBody = ABCyaPhaser.Images.addImage(0,0, `truck-body-${sizeId}`, this).setOrigin(0);
    this.leftWheel = ABCyaPhaser.Images.addImage(0,0,`truck-wheel-${sizeId}`, this);
    this.rightWheel = ABCyaPhaser.Images.addImage(0,0,`truck-wheel-${sizeId}`, this);

    this.leftWheel.x = (this.leftWheel.width / 6) + (this.leftWheel.width / 2);
    this.leftWheel.y = this.carBody.height - (this.leftWheel.height / 3) + (this.leftWheel.height / 2);
    this.rightWheel.x = this.carBody.width - (this.rightWheel.width * 1.1) + (this.rightWheel.width / 2);
    this.rightWheel.y = this.carBody.height - (this.rightWheel.height / 3) + (this.rightWheel.height / 2);

    // store height
    this.carHeight = this.leftWheel.y + (this.leftWheel.height / 2);
  }

  turnWheels (speed) {
    this.rightWheel.angle += speed * 5;
    this.leftWheel.angle += speed * 5;
  }
}